import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import { InputItem, InputRow } from '../Shared/Forms/';
import SvgBarcodeliga from '../../shared/icons/osstell-light/BarcodeLiga';
import styled from 'styled-components';

import gs1Parser from '../../modules/gs1-parser';

import { appInsights } from '../../utils/applicationInsights';

class ImplantSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFrequentlyUsedImplant: -1,
      selectedImplantBrand: '',
    };

    this.intl = props.intl;

    this.implantBrandSelected = this.implantBrandSelected.bind(this);
    this.implantListSelected = this.implantListSelected.bind(this);
    this.setSelectedImplant = this.setSelectedImplant.bind(this);
    this.frequentlyUsedImplantSelected = this.frequentlyUsedImplantSelected.bind(this);
    this.getBrands = this.getBrands.bind(this);
    this.getFrequentlyUsed = this.getFrequentlyUsed.bind(this);
    this.getList = this.getList.bind(this);
    this.boundOnScan = this.onScan.bind(this);
    this.setErrorMessages = this.setErrorMessages.bind(this);

    if (props.implants && props.implants.length > 0 && props.dataId > 0) {
      const implant = props.implants.find((x) => x.dataId === Number(props.dataId));
      if (implant) {
        this.state.selectedImplantBrand = implant.brandName;
      }
    }
  }

  // async getGuididJson(udi) {
  //   const response = await fetch(
  //     `https://accessgudid.nlm.nih.gov/api/v2/devices/lookup.json?udi=${udi}`
  //   )
  //     .then((response) => {
  //       if (!response.ok) throw Error(response.statusText);
  //       return response;
  //     })
  //     .then((res) => res.json())
  //     .catch((error) => {
  //       console.log('Error', error);
  //       return { message: error, isError: true };
  //     });
  //   return response;
  // }

  setErrorMessages(errorMessage) {
    this.props.setErrorMessages({
      messages: [
        {
          text: errorMessage,
          id: 'NoMatch',
        },
      ],
    });
  }

  async onScan(e) {
    var evt = { target: { value: e.detail } };
    var diNumberFound;
    var parsedLotNumber;
    var foundInOurDb;
    var barCodeStandard;

    this.props.resetImplantModalState();
    this.setState({ selectedImplantBrand: '', selectedFrequentlyUsedImplant: -1 });
    var parsingSuccess;

    // gs1 standard
    if (evt.target.value[0] === '\x1D') {
      barCodeStandard = 'gs1';
      const udi = evt.target.value.replace('\x1D', '').trim();
      var result;

      try {
        result = gs1Parser(udi);
      } catch (error) {
        this.setErrorMessages(
          this.intl.formatMessage({
            id: 'addimplant.noMatchOnScan1',
            defaultMessage: `This barcode was not parsable. Barcode standard: GS1.}`,
          })
        );
        parsingSuccess = false;
        appInsights.trackEvent({
          name: 'ScannedArticleFail',
          properties: {
            type: this.props.type,
            barCodeStandard: barCodeStandard,
            parsingSuccess: false,
            foundInOurDb: false,
            barCode: evt.target.value,
            parsedLotNumber: false,
            userId: this.props.userId,
            email: this.props.email,
          },
        });
      }

      // go through all elements parsed and set di and lot if found
      if (result && result.parsedCodeItems) {
        parsingSuccess = true;
        result.parsedCodeItems.forEach((parsedElement) => {
          if (parsedElement.ai === '01') {
            diNumberFound = parsedElement.data;
          }

          if (parsedElement.ai === '10') {
            parsedLotNumber = parsedElement.data;
          }
        });
      }
    } else {
      this.setErrorMessages(
        this.intl.formatMessage({
          id: 'addimplant.noMatchOnScan2',
          defaultMessage: `No barcode standard we support was detected.`,
        })
      );
      parsingSuccess = false;

      appInsights.trackEvent({
        name: 'ScannedArticleFail',
        properties: {
          type: this.props.type,
          barCodeStandard: false,
          parsingSuccess: false,
          foundInOurDb: false,
          barCode: evt.target.value,
          parsedLotNumber: false,
          userId: this.props.userId,
          email: this.props.email,
        },
      });
    }

    if (parsingSuccess) {
      // same for all parsers
      if (diNumberFound)
        foundInOurDb = this.props.implants.find((implant) => implant?.udi === diNumberFound);

      if (foundInOurDb) {
        this.setSelectedImplant(foundInOurDb.dataId);
      }

      if (parsedLotNumber) {
        this.props.lotChanged({ target: { value: parsedLotNumber } });
      }

      if (foundInOurDb && parsedLotNumber) {
        appInsights.trackEvent({
          name: 'ScannedArticleSuccess',
          properties: {
            type: this.props.type,
            barCodeStandard: barCodeStandard,
            barCode: evt.target.value,
            parsedLotNumber: parsedLotNumber,
            userId: this.props.userId,
            email: this.props.email,
          },
        });
      } else {
        appInsights.trackEvent({
          name: 'ScannedArticleFail',
          properties: {
            type: this.props.type,
            barCodeStandard: barCodeStandard,
            parsingSuccess: parsingSuccess,
            foundInOurDb: foundInOurDb,
            barCode: evt.target.value,
            parsedLotNumber: parsedLotNumber,
            userId: this.props.userId,
            email: this.props.email,
          },
        });
      }

      if (!foundInOurDb && !parsedLotNumber) {
        this.setErrorMessages(
          this.intl.formatMessage({
            id: 'addimplant.noMatchOnScan3',
            defaultMessage: `Barcode was parsed but it didn't contain a LOT-number and we don't have a match on the UDI number to our SmartPeg reference list.`,
          })
        );
      } else if (!foundInOurDb) {
        this.setErrorMessages(
          this.intl.formatMessage({
            id: 'addimplant.noMatchOnScan4',
            defaultMessage: `The Lot-number was parsed but we don't have a match on the UDI number to our SmartPeg reference list.`,
          })
        );
      } else if (!parsedLotNumber) {
        this.setErrorMessages(
          this.intl.formatMessage({
            id: 'addimplant.noMatchOnScan5',
            defaultMessage: `We found a match on the UDI number to our SmartPeg reference list but the barcode didn't contain a LOT-number.`,
          })
        );
      }
    }
  }

  implantBrandSelected(evt) {
    this.setState({
      selectedImplantBrand: evt.target.value,
      selectedFrequentlyUsedImplant: -1,
    });
    this.props.onImplantSelected(-1);
  }

  implantListSelected(evt) {
    this.setState({
      selectedFrequentlyUsedImplant: -1,
    });
    this.props.onImplantSelected(evt.target.value);
  }

  setSelectedImplant(dataId) {
    const implant = this.props.implants.find((x) => x.dataId === Number(dataId));
    if (implant) {
      const evt = { target: { value: implant.brandName } };
      this.implantBrandSelected(evt);
      this.props.onImplantSelected(dataId);
    }
  }

  frequentlyUsedImplantSelected(evt) {
    this.setSelectedImplant(evt.target.value);
    this.setState({
      selectedFrequentlyUsedImplant: evt.target.value,
    });
  }

  getBrands() {
    if (!this.props.implants || this.props.implants.length === 0) return [];
    let tempBrands = [];
    var implantStatus = this.props.study ? 3 : 0;
    tempBrands = this.props.implants.filter((imp) => imp.status === implantStatus);
    tempBrands = tempBrands
      .map((x) => {
        return x.brandName;
      })
      .filter((v, i, a) => a.indexOf(v) === i)
      .map((x) => {
        return { value: x };
      });
    tempBrands.sort(function (a, b) {
      return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
    });
    return tempBrands;
  }

  getFrequentlyUsed() {
    if (
      !this.props.implants ||
      this.props.implants.length === 0 ||
      this.props.usedImplants === undefined
    )
      return [];

    let implantList = [];
    this.props.usedImplants.forEach((x) => {
      const implant = this.props.implants.find((imp) => imp.dataId === x.dataId);
      if (implant !== undefined && implant.status === 0) {
        implantList.push({
          key: implant.dataId,
          value:
            implant.brandName +
            (implant.modelName ? ', ' + implant.modelName : '') +
            (implant.platformName ? ', ' + implant.platformName : '') +
            (implant.diameter ? ', D' + implant.diameter : '') +
            (implant.length ? ', L' + implant.length : '') +
            (implant.partNumber ? ', ' + implant.partNumber : ''),
        });
      }
    });
    return implantList;
  }

  getList() {
    if (this.state.selectedImplantBrand === '') return [];
    var implantStatus = this.props.study ? 3 : 0;
    let list = [];
    list = this.props.implants.filter(
      (x) => x.brandName === this.state.selectedImplantBrand && x.status === implantStatus
    );
    list = list.map((x) => {
      return {
        key: x.dataId,
        value:
          (x.modelName ? x.modelName + ', ' : '') +
          (x.platformName ? x.platformName + ', ' : '') +
          (x.diameter ? 'D' + x.diameter + ', ' : '') +
          (x.length ? 'L' + x.length + ', ' : '') +
          (x.partNumber ? x.partNumber : ''),
      };
    });
    list = list.sort(function (a, b) {
      return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
    });
    return list;
  }

  componentDidMount() {
    if (window.ReactNativeWebView) {
      window.addEventListener('barcode', this.boundOnScan, true);
    }
  }

  componentWillUnmount() {
    if (window.ReactNativeWebView) {
      window.removeEventListener('barcode', this.boundOnScan, true);
    }
  }

  render() {
    return (
      <div>
        {window.ReactNativeWebView && (
          <>
            <StyledLabel>
              {this.intl.formatMessage({
                id: 'addimplant.populateByScanningBarcode',
                defaultMessage: 'Populate by scanning QR-code or barcode',
              })}
            </StyledLabel>
            <StyledScanButton
              onClick={() => {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    type: 'startscan',
                    scanText: this.intl.formatMessage({
                      id: 'app.scanbarcode',
                      defaultMessage: 'Scan the UDI number',
                    }),
                  })
                );
              }}
            >
              <SvgBarcodeliga className={'icon'} width={'40'} />
            </StyledScanButton>
          </>
        )}
        {!this.props.study && (
          <>
            <InputRow>
              <InputItem
                label={this.intl.formatMessage({
                  id: 'addimplant.populateFromfrequentlyUsed',
                  defaultMessage: 'Populate from frequently used',
                })}
                type="select"
                options={this.getFrequentlyUsed()}
                noTranslate
                defaultKey={-1}
                defaultValue={this.intl.formatMessage({
                  id: 'addimplant.pleaseSelect',
                  defaultMessage: '- Please select -',
                })}
                value={this.state.selectedFrequentlyUsedImplant}
                onChange={(evt) => {
                  this.frequentlyUsedImplantSelected(evt);
                  this.props.setErrorMessages(undefined);
                }}
                onWhite
              />
            </InputRow>
            <StyledBorder />
          </>
        )}
        <InputRow>
          <InputItem
            label={this.intl.formatMessage({ id: 'addimplant.brand', defaultMessage: 'Brand' })}
            type="select"
            options={this.getBrands()}
            noTranslate
            defaultKey={-1}
            defaultValue={this.intl.formatMessage({
              id: 'addimplant.pleaseSelect',
              defaultMessage: '- Please select -',
            })}
            value={this.state.selectedImplantBrand}
            onChange={(evt) => {
              this.implantBrandSelected(evt);
              this.props.setErrorMessages(undefined);
            }}
            onWhite
          />
        </InputRow>
        {this.state.selectedImplantBrand !== '' ? (
          <InputRow>
            <InputItem
              label={this.intl.formatMessage({ id: 'addimplant.list', defaultMessage: 'List' })}
              type="select"
              options={this.getList()}
              noTranslate
              defaultKey={-1}
              defaultValue={this.intl.formatMessage({
                id: 'addimplant.pleaseSelect',
                defaultMessage: '- Please select -',
              })}
              value={this.props.dataId}
              onChange={(evt) => {
                this.implantListSelected(evt);
                this.props.setErrorMessages(undefined);
              }}
              onWhite
            />
          </InputRow>
        ) : null}
        <InputRow>
          <InputItem
            label={this.intl.formatMessage({
              id: 'addimplant.batchLotNumber',
              defaultMessage: 'Batch/Lot number',
            })}
            type="text"
            value={this.props.lot}
            onChange={(evt) => {
              this.props.lotChanged(evt);
              this.props.setErrorMessages(undefined);
            }}
            onWhite
          />
        </InputRow>
      </div>
    );
  }
}

const StyledLabel = styled.label`
  font-size: 1rem;
  font-weight: 400;
  color: black;
  line-height: 1.5rem;
  display: block;
  height: 1.5rem;
  margin-bottom: 0.25rem;
  display: block;
`;

const StyledScanButton = styled.div`
  border: 'solid red 3px';
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(237, 238, 247);
  height: 48px;
  border-radius: 8px;
  width: 100%;
  .icon {
    display: block;
    top: 2px;
  }
`;

const StyledBorder = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #edeef7;
  margin: 5px 0 5px 0;
`;

export default injectIntl(ImplantSelector);
